import { getTherapyPlanningPatientReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanningPatientReducer_2.0';
import { checkSignatureDailyNotesReducer } from './dailySessionNotes/checkSignatureDailyNotesReducer';
import { getLocationTypeLaborHrReducer } from './loborHoursReducer/getLocationTypeLaborHrReducer';
import { editLaborHoursReducer } from './loborHoursReducer/editLaborHoursReducer';
import { addLaborHoursReducer } from './loborHoursReducer/addLaborHoursReducer';
import { getLaborHoursReducer } from './loborHoursReducer/getLaborHoursReducer';
import { getLaborCodesReducer } from './loborHoursReducer/getLaborCodesReducer';
import { getAuthorizationDetailsReducer } from './therapyPlanning/getAuthorizationDetails';
import { editAuthorizationReducer } from './therapyPlanning/editAuthorizationReducer';
import { getCptCodeByDisciplineReducer } from './therapyPlanning/getCptCodeByDisciplineReducer';
import { thePayComeDetailsReducer } from './therapistReducers/thePayComeDetailsReducer';
import { updateTimeBasisReducer } from './therapistReducers/updateTimeBasisReducer';
import { clockInOutButtonVisibilityReducer } from './therapistReducers/clockInOutButtonVisibilityReducer';
import { autoMatchingThearpistReducer } from './therapistReducers/autoMatchingTherapistReducer';
import { disableAutoMatchReducer } from './therapistReducers/disableAutoMatchReducer';
import { defaultThearpistAssignReducer } from './therapistReducers/defaultTherapistAssignReducer';
import { dashboardGamesInterventionReducer } from './therapist-dashoard-reducer/dashboard-games-intervention-reducer';
import { dashboardInterventionGroupReducer } from './therapist-dashoard-reducer/dashboard-intervention-group-reducer';
import { getAllPatientReducer } from './patientReducer/getAllPatientReducer';
import { getSingleTherapistDisciplineReducer } from './patientReducer/patientSingleTherapistDiscipline';
import { getTreatmentTherapistReducer } from './patientReducer/putTreatmentTherapistReducer';
import { getAllTherapistDisciplineReducer } from './patientReducer/getAllTherapistDiscipline';
import { getListOfTherapistAvaiReducer } from './MyAvailabilatyReducer/getListOfTherapistAvaiReducer';
import { dashboardPtoUpdateReducer } from './therapist-dashoard-reducer/dashboard-pto-update-reducer';
import { postScreeningSubmissionReducer } from './screeningReducers/post-screening-submission-reducer';
import { getFormIdForScreeningReducer } from './screeningReducers/getFormIdForScreeningReducer';
import { dashboardPatientInfo } from './therapist-dashoard-reducer/dashboard-patient-info-reducer';
import { getEpisodeOfCareRequiredDocumentReducer } from './episodeOfCare/getRequiredDocumentReducer';
import { checkoutReducer } from './therapist-dashoard-reducer/dashboard-time-out';
import { checkInReducer } from './therapist-dashoard-reducer/dashboard-timeCheck-in';
import { dashboardOverviewReducer } from './therapist-dashoard-reducer/dashboard-overview-reducer';
import { dashboardDocumentationReducer } from './therapist-dashoard-reducer/dashboard-documentation-reducer';
import { dashboardTherapyReducer } from './therapist-dashoard-reducer/dashboard-therapy-reducer';
import { dashboardDocumentListReducer } from './therapist-dashoard-reducer/dashboard-document-list-reducer';
import { getDashboardPatientReducer } from './therapist-dashoard-reducer/therapist-dashboard-patientlist-reducer';
import { getTodayPatientListReducer } from './therapist-dashoard-reducer/today-patient-list-reducer';
import { therapistDialogAssignTaskReducer } from './therapistReducers/therapistDialogAssignTaskReducer';
import { editTaskTimeReducer } from './therapistReducers/editTaskTimeReducer';
import { taskAvailabilityReducer } from './therapistReducers/taskAvailabilityReducer';
import { reassignTherapistTaskReducer } from './therapistReducers/rearrangeTherapistTaskReducer';
import { therapistAssignUndoReducer } from './therapistReducers/therapistAssignmentUndoReducer';
import { therapistSchedulingTaskEditReducer } from './therapistReducers/therapistSchedulingTaskEditReducer';
import { combineReducers } from 'redux';
import { createPtoRequestReducer } from './MyAvailabilatyReducer/createPtoRequestReducer';
import { editMyAvailabilityReducer } from './MyAvailabilatyReducer/edit-MyAvailabilatyReducer';
import { getAllPtoRequestReducer } from './MyAvailabilatyReducer/getAllPtoRequestReducer';
import { getMyAvailabilityReducer } from './MyAvailabilatyReducer/getMyAvailabilityReducer';
import { removePtoRequestReducer } from './MyAvailabilatyReducer/removePtoRequestReducer';
import { autoGeneratePasswordReducer } from './authReducers/autoGeneratePasswordReducer';
import { postPasswordResetReducer } from './authReducers/postPasswordResetReducer';
import { setPasswordReducer } from './authReducers/setPasswordReducer';
import { therapistLoginReducer } from './authReducers/therapistLoginReducer';
import { therapistLogoutReducer } from './authReducers/therapistLogoutReducer';
import { createEpisodeOfCareReducer } from './episodeOfCare/createEpisodeOfCare';
import { closeEpisodeOfCareReducer } from './episodeOfCare/closeEpisodeOfCare';
import { editEpisodeOfCareReducer } from './episodeOfCare/editEpisodeOfCare';
import { getEpisodeOfCare } from './episodeOfCare/getEpisodeOfCare';
import { getAllFilteredTherapistsReducer } from './therapistReducers/schedularTherapistFilterReducer';
import { getSingleEpisodeOfCare } from './episodeOfCare/getSingleEpisodeOfCare';
import { getFacilityDropDownReducer } from './facilityReducers/assignedFacilities';
import { createFacilityStayReducer } from './facilityReducers/createFacilityStaysReducer';
import { getAllFacilitiesStaysReducer } from './facilityReducers/getAllFacilitiesReducer';
import { storeFacilityUuidReducer } from './facilityReducers/storeFacilityUuidReducer';
import { updateFacilityDropDownReducer } from './facilityReducers/switchFacilityReducer';
import { updateFacilityStayReducer } from './facilityReducers/updateFacilityReducer';
import { createPatientReducer } from './patient/createPatientReducer';
import { deactivatePatientReducer } from './patient/deactivatePatientReducer';
import { editPatientReducer } from './patient/editPatientReducer';
import { getEnterprisePhysicianReducer } from './patient/getAllPhysicianReducer';
import { getPatientIdReducer } from './patient/getPatientIdReducer';
import { getSinglePatientReducer } from './patient/getSinglePatientReducer';
import { selectPatientReducer } from './patient/selectPatientReducer';
import { getAllPatientPriorChargesReducer } from './patient/getAllPatientPriorChargesReducer';
import { getPatientReducer } from './patientReducer/patientReducers';
import { createScreeningReducer } from './screeningReducers/createScreeningReducer';
import { editScreeningReducer } from './screeningReducers/editScreeningReducer';
import { getScreeningReducer } from './screeningReducers/getAllScreeningReducer';
import { getDisciplineTypeReducer } from './screeningReducers/getDisciplineTypeReducer';
import { getScreeningTypeReducer } from './screeningReducers/getScreeningTypeReducer';
import { getSingleScreeningReducer } from './screeningReducers/getSingleScreeningReducer';
import { AddTaskToTherapistReducer } from './therapistReducers/AddTaskToTherapistReducer';
import { getAllTherapistTaskReducer } from './therapistReducers/getAllTherapistTaskReducer';
import { getAllTherapistTaskTypeReducer } from './therapistReducers/taskTypeReducer';
import { therapistAssignTaskReducer } from './therapistReducers/therapistAssignTask';
import { therapistMigrateTaskReducer } from './therapistReducers/therapistMigrateTaskReducer';
import { migrateTherapistPatientReducer } from './therapistReducers/therapistMigratePatientReducer';
import { therapistDiciplineReducer } from './therapistReducers/therapistDiciplineReducer';
import { getTherapistListReducer } from './therapistReducers/therapistListReducer';
import { getTherapistProfileReducer } from './therapistReducers/therapistProfileReducer';
import { getAppointmentSlotsReducer } from './therapistReducers/getAppointmentSlotsReducer';
import { scheduleAppointmentReducer } from './therapistReducers/scheduleAppointmentReducer';
import { isRecurringEditReducer } from './therapistReducers/isRecurringEditReducer';
import { scheduleRecurringAppointmentReducer } from './therapistReducers/scheduleRecurringAppointmentReducer';
import { updateRecurringSeriesReducer } from './therapistReducers/updateRecurringSeriesReducer';
import { cancelRecurringSeriesReducer } from './therapistReducers/cancelRecurringSeriesReducer';
import { getPatientTimeSlotsReducer } from './therapistReducers/getPatientTimeSlotsReducer';
import { getRecurringAppointmentCountReducer } from './therapistReducers/getRecurringAppointmentCountReducer';
import {
  createAssessmentReducer,
  getAssessmentReducer,
  getMDSAssessmentReducer,
  getPlanOfCareReducer,
  getTherapyPlanningReducer,
  updateAssessmentReducer,
  getTherapyPlanningPatientReducer,
  checkTherapyPlanningReducer,
  updateTherapyPlanningReducer,
  updateTherapyPlanningDischargeDateReducer,
  getCaseMixGroupReducer,
  getCmgResolutionReducer,
  getCmgStatusReducer,
  getPdpmFeatureToggleReducer,
  getDateOfServiceReducer,
} from './therapyPlanning';
import { getPayerPlanTypeReducer } from './patient/getPayerPlanTypeReducer';
import { getAllFaciltiesReducer } from './facilityReducers/getAllFacilitiesDropdownReducer';
import { getAllTemplatesReducer } from './documentationReducers/getAllTemplatesReducer';
import { callSubmitEventReducer } from './documentationReducers/callSubmitEventReducer';
import { getAllSubmittedDocumentReducer } from './documentationReducers/getAllSubmittedDocumentReducer';
import { getSubmissionDocumentReducer } from './documentationReducers/getSubmissionDocumentReducer';
import {
  getDailySessionPatientInfo,
  getDailySessionPatientList,
  updateSoapNoteReducer,
  getDailySessionNotes,
  updateDailySessionNotes,
  getDailySessionOtherPatientList,
} from './dailySessionNotes';
import { getAllTherapistReducer } from './therapistReducers/getAllTherapistReducer';
import { getAllTherapistsByRoleReducer } from './therapistReducers/getAllTherapistsByRoleReducer';
import { getSignatureTemplateReducer } from '../saga/documentation/getSignatureTemplateReducer';
import { getAllMiscellaneousDocumentsReducer } from './documentationReducers/getAllMiscellaneousDocumentsReducer';
import { saveMiscellaneousDocumentsReducer } from './documentationReducers/saveMiscDocumentReducer';
import { getAllSupervisorsReducer } from './documentationReducers/getAllSupervisiorsReducer';
import { getNoteTemplateReducer } from './dailySessionNotes/getNoteTemplateReducer';
import { submitEsignReducer } from './dailySessionNotes/submitEsignReducer';
import { getPatientActiveInActiveCountReducer } from './patientReducer/getPatientInActiveCountReducer';
import { switchDisciplineReducer } from './patient/switcDiciplineReducer';
import {
  getDepartmentDashboardCountReducer,
  getDepartmentPTOReducer,
  getDepartmentTherapyMinReducer,
  updateDepartmentPTORequestReuder,
  getPhysicianSignaturePendingReducer,
  getAllPhysiciansReducer,
  getPendingSignaturePhysiciansReducer,
} from './departmentDashboard';
import { sendMailToPhysicianReducer } from './documentationReducers/sendMailToPhysicianReducer';
import { getMonthEndAlertCountReducer } from './monthEndAlertsReducers/getMonthEndAlertCountReducer';
import { getThemeCountReducer } from './monthEndAlertsReducers/getThemeCountReducer';
import { getOwnerAlertCountReducer } from './monthEndAlertsReducers/getOwnerAlertCountReducer';
import { getListofMonthEndAlertReducer } from './monthEndAlertsReducers/getListofMonthEndAlertReducer';
import { getAllCodeReducers } from './documentationReducers/getAllCodesReducers';
import { getDownloadCSVTemplateReducer } from './patientReducer/getDownloadCSVTemplateReducer';
import { validateCSVTemplateReducer } from './patientReducer/validateCSVTemplateReducer';
import { uploadCsvTemplateReducer } from './patientReducer/uploadCsvTemplateReducer';
import { getRecentUploadedReducer } from './patientReducer/getRecentUploadedReducer';
import { getPatientExportCsvReducer } from './patientReducer/getPatientExportCsvReducer';
import { certifyMonthEndAlertReducer } from './monthEndAlertsReducers/certifyMonthEndAlertReducer';
import { getCertificationStatusReducer } from './monthEndAlertsReducers/getCertifyStatusReducer';
import { getSignatureAccessReducer } from './documentationReducers/getSignatureAccessReducer';
import { getTargetSignatureAccessReducer } from './documentationReducers/getTargetSignatureAccessReducer';
import { getSkillsListReducer } from './therapistReducers/getTherapistSkillListReducer';
import { getAllICDCodeReducers } from './documentationReducers/getICDcodesReducer';
import { pullUuidRducder } from './documentationReducers/pullUuidReducer';
import { storeSubdomainReduxReducer } from './storeSubdomainReduxReducer';
import { reAssigntherapistReducer } from './documentationReducers/reAssignTherapistReducer';
import { getAllTherapistListReducer } from './documentationReducers/getAllProviderListReducer';
import { loaderDocumenattionReducer } from './documentationReducers/loaderDocumnetationReducer';
import { deleteTaskPatientReducer } from './therapistReducers/deleteTaskReducer';
import { deleteLaborHoursReducer } from './loborHoursReducer/deleteLaborHoursReducer';
import { getNpcEntriesReducer } from './npcLogReducer/getNpcEntriesReducer';
import { getNpcActivityTypesReducer } from './npcLogReducer/getNpcActivityTypesReducer';
import { addNpcEntryReducer } from './npcLogReducer/addNpcEntryReducer';
import { editNpcEntryReducer } from './npcLogReducer/editNpcEntryReducer';
import { deleteNpcEntryReducer } from './npcLogReducer/deleteNpcEntryReducer';
import { getNpcTeamEntriesReducer } from './npcLogReducer/getNpcTeamEntriesReducer';
import { getNpcTeamEntriesEditableReducer } from './npcLogReducer/getNpcTeamEntriesEditableReducer';
import { reviewNpcEntryReducer } from './npcLogReducer/reviewNpcEntryReducer';
import { getLaborReportReducer } from './loborHoursReducer/getLaborReportReducer';
import { getBuildingsOverviewReducer } from './loborHoursReducer/getBuildingsOverviewReducer';
import { getLaborEntryHistoryReducer } from './loborHoursReducer/getLaborEntryHistoryReducer';
import { updateLaborEntryStatusReducer } from './loborHoursReducer/updateLaborEntryStatusReducer';
import { getLaborValidationToggleReducer } from './loborHoursReducer/getLaborValidationToggleReducer';
import { getPayPeriodCyclesReducer } from './loborHoursReducer/getPayPeriodCyclesReducer';
import { approvePayPeriodReducer } from './loborHoursReducer/approvePayPeriodReducer';
import { getPayPeriodByDateReducer } from './loborHoursReducer/getPayPeriodByDateReducer';
import { getAllDisciplineTherapistReducer } from './therapistReducers/getAllDisciplineTherapist';
import { monthlyCloseOutAlertReducer } from './monthlyCloseout/monthlyCloseOutAlert';
import { getUnlockTherapistReducer } from './unlockTherapistReducer/getUnlockTherapistReducer';
import { getLockDailySessionNote } from './unlockTherapistReducer/getLockDailySessionNotes';
import { updateUnlockTherapistReducer } from './unlockTherapistReducer/updateUnlockTherapistReducer';
import { uploadSignatureFileReducer } from './monthlyCloseout/uploadSignatureFileReducer';
import { getMultipleMDSAssessment } from './therapyPlanning/getMultipleMdsAssessment';
import { deleteRequiredDocumentReducer } from './documentationReducers/deleteRequiredDocumentReducer';
import { getPrepareProgressNoteReducer } from './documentationReducers/getPrepareProgressNoteReducer';
import { getAllPatientsReducer } from './patientReducer/getPaginationPatientRecord';
import { getIsTherapyPlanningPatientReducer } from './therapyPlanning/getIsTherapyPlanningPatient';
import { getAllCompetedDocReducer } from './documentationReducers/getAllCompetedDocReducer';
import { dashboardDocumentListCsv } from './therapist-dashoard-reducer/dashboard-document-list-csv-reducer';
import { getCPTCodeScriptionReducer } from './copyTextBank/getCPTCodesDescriptionReducer';
import { validateMDSAssessmentCsv } from './therapyPlanning/validateMdsAssessmentCsv';
import { uploadCsvTemplateMdsReducer } from './therapyPlanning/uploadCsvTemplateMdsReducer';
import { getAllPatientListReducer } from './patientReducer/getAllPatientListReducer';
import { getContractCountReducer } from './contract/getContractCountReducer';
import { physicianDocumentsReducer } from './physicianReducer/physicianDocumentsReducer';
import { updateDocumentStatusesReducer } from './physicianReducer/updateDocumentStatusesReducer';
import { getFacilityReducer } from './physicianReducer/getAllfacilitiesReducer';
import { getAllPatientByEnterpriseReducer } from './physicianReducer/getAllPatientOfEnterrpsieReducer';
import { checkAssignTaskPTOReducer } from './departmentDashboard/checkTaskOfPTOReducer';
import { completedPhysicianDocumentReducer } from './physicianReducer/completedPhysicianDocumentReducer';
import { preventNavigationReducer } from './documentationReducers/navigation-prevent-reducer';
import { mdsWorksheetDirtyReducer } from './mdsDashboardReducers/mds-worksheet-dirty-reducer';
import { dashboardCreateEditDocumentDataReducer } from './documentationReducers/dashboardCreateEditDocumentDataReducer';
import { eocCreateDocumentDataReducer } from './documentationReducers/eocCreateDocumentDataReducer';
import { eocEditDocumentDataReducer } from './documentationReducers/eocEditDocumentDataReducer';
import { checkIsReformReducer } from './documentationReducers/checkIsReformReducer';
import { getTherapyPlanningDataReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanningDataReducer_2.0';
import { getTherapyPlanningSummaryReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanningSummary_2.0';
import { editSingleCellOfTherapyPlanningReducer } from './therapyPlanning/therapyPlanning_2.0/editSingleCellTherapyPlanningReducer';
import { updateAppointmentEndTimeReducer } from './therapyPlanning/therapyPlanning_2.0/updateAppointmentEndTimeReducer';
import { updateUncoveredDayIn_TP20_reducer } from './therapyPlanning/therapyPlanning_2.0/updateUncoveredDayTherapyPlanning_2.0';
import { getTherapyPlanningDischargeDateReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanningDischargeDateReducer_2_0';
import { copyPasteTherapyPlanningReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/copyPasteTherapyPlanningReducer_2.0';
import { applyTheTherapyTemplatesReducer } from './therapyPlanning/therapyPlanning_2.0/applyTheTherapyTemplatesReducer';
import { getTherapistTaskNoteReducer } from './schedular/get-therapist-task-note-reducer';
import { createTherapistTaskNoteReducer } from './schedular/create-therapist-task-note-reducer';
import { deleteTherapistTaskNoteReducer } from './schedular/delete-therapist-task-note-reducer';
import { createNewTherapyTemplateReducer } from './therapyPlanning/therapyPlanning_2.0/createNewTherapyTemplateReducer';
import { getAllTherapyPlaningTemplatesReducer } from './therapyPlanning/therapyPlanning_2.0/getAllTherapyPlanningTemplatesReducer';
import { deleteTherapyTemplateReducer } from './therapyPlanning/therapyPlanning_2.0/deleteTherapyTemplateReducer';
import { applySelectedTherapyPlanningTemplateReducer } from './therapyPlanning/therapyPlanning_2.0/applySelectedTherapyTemplateReducer';
import { editTherapyTemplateReducer } from './therapyPlanning/therapyPlanning_2.0/editTherapyTemplateReducer';
import { therapistPatientUnAssignReducer } from './therapistReducers/therapistPatientUnAssignReducer';
import { getAllMaintainedTherapist } from './therapistReducers/getAllMaintainedTherapistsReducer';
import { maintainTherapistsFilterReducer } from './therapistReducers/maintainTherapistFilterReducer';
import { getAllAnnouncementReducer } from './schedular/get-all-announcements-reducer';
import { createAnnouncementReducer } from './schedular/create-schedular-announce-reducer';
import { updateAnnouncementReducer } from './schedular/update-schedular-announce-reducer';
import { deleteAnnouncementReducer } from './schedular/delete-schedular-announce-reducer';
import { getMdsAssessmentRangeReducer } from './therapyPlanning/therapyPlanning_2.0/getMdsAssessmentRangeReducer';
import { getPayerDayCountReducer } from './therapyPlanning/therapyPlanning_2.0/getPayerDayCountReducer';
import { getFiveDayArdWindowReducer } from './therapyPlanning/getFiveDayArdWindowReducer';
import { getSingleMdsAssessmentReducer } from './therapyPlanning/therapyPlanning_2.0/getSingleMdsAssessmentReducer';
import { deleteMdsAssessmentByDateReducer } from './therapyPlanning/therapyPlanning_2.0/deleteMdsAssessmentByDateReducer';
import { deleteSingleMdsAssessmentReducer } from './therapyPlanning/therapyPlanning_2.0/deleteSingleMdsAssessmentReducer';
import { getTherapyPlanning7dayLookBack } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanning7dayLookback';
import { therapistDailyUpdatesReducer } from './therapist-dashoard-reducer/dashboard-therapist-daily-update-reducer';
import { dashboardSupervisorEditReducer } from './therapist-dashoard-reducer/dashboard-supervisor-edit-reducer';
import { checkAllowDischargeReducer } from './documentationReducers/check-allow-discharge-reducer';
import { recheckDischargeOverrideStatusReducer } from './documentationReducers/recheck-discharge-override-status-reducer';
import { approveRecheckDischargeReducer } from './documentationReducers/approve-recheck-discharge-reducer';
import { newDocumentSignReducer } from './documentationReducers/newDocumentSignReducer';
import { undoDocumentSignReducer } from './documentationReducers/undoDocumentSignReducer';
import { holdDailyNoteFromBillingReducer } from './documentationReducers/holdDailyNoteFromBillingReducer';
import { checkPendingDocsAlert } from './documentationReducers/check-pending-docs-alert';
import { setCommonDurationReducer } from './therapistReducers/setCommonDurationReducer';
import { dueDocSettingsReducer } from './documentationReducers/dueDocSettingsReducer';
import { otherDashboardDocumentListReducer } from './therapist-dashoard-reducer/therapist-bulk-signature/otherDashboardDocumentListReducer';
import { myDashboardDocumentListReducer } from './therapist-dashoard-reducer/therapist-bulk-signature/myDashboardDocumentListReducer';
import { coSignatureReviewReducer } from './therapist-dashoard-reducer/therapist-bulk-signature/coSignatureReviewReducer';
import { therapistBulkSignatureReducer } from './therapist-dashoard-reducer/therapist-bulk-signature/therapist-bulk-signature';
import { signingPinReducer } from './signing-pin-reducer/signing-pin-reducer';
import { getDailySessionPatientInfoV2 } from './dailySessionNotes/getPatientInfoV2';
import { getDailyNotesPrintStatusReducer } from './dailySessionNotes/getPrintStatusReducer';
import { deleteDailySessionNoteReducer } from './dailySessionNotes/deleteDailySessionNoteReducer';
import { archiveDailySessionNoteReducer } from './dailySessionNotes/archiveDailySessionNoteReducer';
import { getArchivedDocumentsReducer } from './dailySessionNotes/getArchivedDocumentsReducer';
import { SplitTaskMinReducer } from './therapistReducers/split-task/splitTaskMinReducer';
import { editSplitTaskMinReducer } from './therapistReducers/split-task/editSplitTaskMinReducer';
import { getSplitTaskReducer } from './therapistReducers/split-task/getSplitTaskMinReducer';
import { deleteSplitTaskReducer } from './therapistReducers/split-task/deleteSplitTaskReducer';
import { checkSplitMinInPlanner } from './therapistReducers/split-task/check-split-min-reducer';
import { getSupervisoryAlertReducer } from './departmentDashboard/getSupervisoryAlertReducer';
import { getSupervisoryAlertSettingReducer } from './departmentDashboard/getSupervisoryAlertSetting';
import { getTherapistInfoReducer } from './documentationReducers/getTherapistInfoReducer';
import { addSignOnBehalfReducer } from './documentationReducers/addSignOnBehalfReducer';
import { getDsnSummaryReducer } from './therapist-dashoard-reducer/get-dsn-summary';

import { createPatientPayerReducer } from './patientPayer/createPatientPayerReducer';
import { getAllPatientPayersReducer } from './patientPayer/getAllPatientPayerReducer';
import { getPayerOptionsReducer } from './patientPayer/getPayerOptionsReducer';
import { getPayerDateRangesReducer } from './patientPayer/getPayerDateRangesReducer';
import { getPayerHistoryReducer } from './patientPayer/getPayerHistoryReducer';
import { updatePatientPayerReducer } from './patientPayer/updatePatientPayerReducer';
import { validateMdsPayerReducer } from './patientPayer/validateMdsPayerReducer';
import { getPbjExportReducer } from './pbj/getPbjExportReducer';
import { verifyMdsPpsReducer } from './therapyPlanning/verifyMdsPpsReducer';
import { reopenCloseoutReducer } from './monthlyCloseout/reopenCloseoutReducer';
import {
  createCustomCloseoutReducer,
  updateCustomCloseoutReducer,
  cancelCustomCloseoutReducer,
} from './monthlyCloseout/customCloseoutReducer';
import { getPayerFiltersReducer } from './documentBundle/getPayerFiltersReducer';
import { getPatientFiltersReducer } from './documentBundle/getPatientFiltersReducer';
import { getDocumentSummaryReducer } from './documentBundle/getDocumentSummaryReducer';
import { getDownloadJobsReducer } from './documentBundle/getDownloadJobsReducer';
import { submitDownloadJobReducer } from './documentBundle/submitDownloadJobReducer';
import { getPresignedUrlReducer } from './documentBundle/getPresignedUrlReducer';
import { getTherapistFiltersReducer } from './documentBundle/getTherapistFiltersReducer';
import { searchPatientsReducer } from './documentBundle/searchPatientsReducer';
import { getPatientIntervalsReducer } from './documentBundle/getPatientIntervalsReducer';
import { getPatientDocumentsReducer } from './documentBundle/getPatientDocumentsReducer';

const rootRedcer = combineReducers({
  getLaborCodesReducer,
  getSingleTherapistDisciplineReducer,
  checkTherapyPlanningReducer,
  getIsTherapyPlanningPatientReducer,
  dashboardDocumentationReducer,
  dashboardTherapyReducer,
  getAllTherapistDisciplineReducer,
  getDailySessionNotes,
  getDateOfServiceReducer,
  updateSoapNoteReducer,
  getAllDisciplineTherapistReducer,
  editTaskTimeReducer,
  taskAvailabilityReducer,
  getDailySessionOtherPatientList,
  getSkillsListReducer,
  getTreatmentTherapistReducer,
  getCaseMixGroupReducer,
  getCmgResolutionReducer,
  getCmgStatusReducer,
  getPdpmFeatureToggleReducer,
  updateTherapyPlanningDischargeDateReducer,
  getDepartmentDashboardCountReducer,
  getDepartmentPTOReducer,
  getDepartmentTherapyMinReducer,
  updateDepartmentPTORequestReuder,
  getPhysicianSignaturePendingReducer,
  updateDailySessionNotes,
  getDailySessionPatientInfo,
  getDailySessionPatientList,
  getTherapyPlanningReducer,
  updateTherapyPlanningReducer,
  createAssessmentReducer,
  getAssessmentReducer,
  getMDSAssessmentReducer,
  getPlanOfCareReducer,
  updateAssessmentReducer,
  createEpisodeOfCareReducer,
  editEpisodeOfCareReducer,
  getSingleEpisodeOfCare,
  therapistLoginReducer,
  getTherapyPlanningPatientReducer,
  therapistLogoutReducer,
  createPatientReducer,
  editPatientReducer,
  setPasswordReducer,
  getTherapistProfileReducer,
  getSinglePatientReducer,
  getAllPatientPriorChargesReducer,
  closeEpisodeOfCareReducer,
  getFacilityDropDownReducer,
  getEpisodeOfCare,
  updateFacilityDropDownReducer,
  getScreeningReducer,
  storeFacilityUuidReducer,
  getPatientReducer,
  getAllFacilitiesStaysReducer,
  updateFacilityStayReducer,
  getScreeningTypeReducer,
  getDisciplineTypeReducer,
  getSingleScreeningReducer,
  deactivatePatientReducer,
  getPatientIdReducer,
  editScreeningReducer,
  selectPatientReducer,
  createScreeningReducer,
  getEnterprisePhysicianReducer,
  createFacilityStayReducer,
  autoGeneratePasswordReducer,
  postPasswordResetReducer,
  getMyAvailabilityReducer,
  createPtoRequestReducer,
  removePtoRequestReducer,
  getAllPtoRequestReducer,
  editMyAvailabilityReducer,
  getAllTherapistTaskReducer,
  AddTaskToTherapistReducer,
  getAllTherapistTaskTypeReducer,
  getTherapistListReducer,
  getAppointmentSlotsReducer,
  scheduleAppointmentReducer,
  isRecurringEditReducer,
  scheduleRecurringAppointmentReducer,
  updateRecurringSeriesReducer,
  cancelRecurringSeriesReducer,
  getPatientTimeSlotsReducer,
  getRecurringAppointmentCountReducer,
  therapistDiciplineReducer,
  therapistAssignTaskReducer,
  therapistMigrateTaskReducer,
  migrateTherapistPatientReducer,
  getAllFilteredTherapistsReducer,
  therapistSchedulingTaskEditReducer,
  getPayerPlanTypeReducer,
  therapistAssignUndoReducer,
  getAllFaciltiesReducer,
  getAllTemplatesReducer,
  reassignTherapistTaskReducer,
  deleteTaskPatientReducer,
  callSubmitEventReducer,
  getAllSubmittedDocumentReducer,
  getSubmissionDocumentReducer,
  therapistDialogAssignTaskReducer,
  getAllTherapistReducer,
  getAllTherapistsByRoleReducer,
  getSignatureTemplateReducer,
  getAllMiscellaneousDocumentsReducer,
  saveMiscellaneousDocumentsReducer,
  getDashboardPatientReducer,
  getTodayPatientListReducer,
  dashboardDocumentListReducer,
  dashboardOverviewReducer,
  checkInReducer,
  checkoutReducer,
  getAllSupervisorsReducer,
  dashboardPatientInfo,
  getEpisodeOfCareRequiredDocumentReducer,
  getNoteTemplateReducer,
  submitEsignReducer,
  getFormIdForScreeningReducer,
  postScreeningSubmissionReducer,
  getPatientActiveInActiveCountReducer,
  getContractCountReducer,
  switchDisciplineReducer,
  sendMailToPhysicianReducer,
  getMonthEndAlertCountReducer,
  getThemeCountReducer,
  getOwnerAlertCountReducer,
  getListofMonthEndAlertReducer,
  getAllCodeReducers,
  dashboardPtoUpdateReducer,
  getCptCodeByDisciplineReducer,
  editAuthorizationReducer,
  getDownloadCSVTemplateReducer,
  validateCSVTemplateReducer,
  uploadCsvTemplateReducer,
  getRecentUploadedReducer,
  getPatientExportCsvReducer,
  getListOfTherapistAvaiReducer,
  certifyMonthEndAlertReducer,
  getCertificationStatusReducer,
  dashboardInterventionGroupReducer,
  dashboardGamesInterventionReducer,
  getSignatureAccessReducer,
  getTargetSignatureAccessReducer,
  getAllPatientReducer,
  getAuthorizationDetailsReducer,
  getAllICDCodeReducers,
  pullUuidRducder,
  thePayComeDetailsReducer,
  updateTimeBasisReducer,
  clockInOutButtonVisibilityReducer,
  storeSubdomainReduxReducer,
  reAssigntherapistReducer,
  getAllTherapistListReducer,
  loaderDocumenattionReducer,
  getLaborHoursReducer,
  addLaborHoursReducer,
  editLaborHoursReducer,
  getLocationTypeLaborHrReducer,
  checkSignatureDailyNotesReducer,
  deleteLaborHoursReducer,
  getNpcEntriesReducer,
  getNpcActivityTypesReducer,
  addNpcEntryReducer,
  editNpcEntryReducer,
  deleteNpcEntryReducer,
  getNpcTeamEntriesReducer,
  getNpcTeamEntriesEditableReducer,
  reviewNpcEntryReducer,
  getLaborReportReducer,
  getBuildingsOverviewReducer,
  getLaborEntryHistoryReducer,
  updateLaborEntryStatusReducer,
  getLaborValidationToggleReducer,
  getPayPeriodCyclesReducer,
  approvePayPeriodReducer,
  getPayPeriodByDateReducer,
  monthlyCloseOutAlertReducer,
  getUnlockTherapistReducer,
  getLockDailySessionNote,
  updateUnlockTherapistReducer,
  uploadSignatureFileReducer,
  getMultipleMDSAssessment,
  disableAutoMatchReducer,
  autoMatchingThearpistReducer,
  defaultThearpistAssignReducer,
  deleteRequiredDocumentReducer,
  getPrepareProgressNoteReducer,
  getAllPatientsReducer,
  getAllCompetedDocReducer,
  dashboardDocumentListCsv,
  getCPTCodeScriptionReducer,
  validateMDSAssessmentCsv,
  uploadCsvTemplateMdsReducer,
  getAllPatientListReducer,
  physicianDocumentsReducer,
  updateDocumentStatusesReducer,
  getFacilityReducer,
  getAllPatientByEnterpriseReducer,
  checkAssignTaskPTOReducer,
  completedPhysicianDocumentReducer,
  preventNavigationReducer,
  mdsWorksheetDirtyReducer,
  dashboardCreateEditDocumentDataReducer,
  eocCreateDocumentDataReducer,
  eocEditDocumentDataReducer,
  checkIsReformReducer,
  getTherapyPlanningPatientReducer_2_0,
  getTherapyPlanningDataReducer_2_0,
  getTherapyPlanningSummaryReducer_2_0,
  editSingleCellOfTherapyPlanningReducer,
  updateAppointmentEndTimeReducer,
  updateUncoveredDayIn_TP20_reducer,
  getTherapyPlanningDischargeDateReducer_2_0,
  copyPasteTherapyPlanningReducer_2_0,
  applyTheTherapyTemplatesReducer,
  getAllTherapyPlaningTemplatesReducer,
  deleteTherapyTemplateReducer,
  applySelectedTherapyPlanningTemplateReducer,
  createNewTherapyTemplateReducer,
  editTherapyTemplateReducer,
  getTherapistTaskNoteReducer,
  createTherapistTaskNoteReducer,
  deleteTherapistTaskNoteReducer,
  therapistPatientUnAssignReducer,
  getMdsAssessmentRangeReducer,
  getPayerDayCountReducer,
  getFiveDayArdWindowReducer,
  getSingleMdsAssessmentReducer,
  deleteMdsAssessmentByDateReducer,
  deleteSingleMdsAssessmentReducer,
  maintainTherapistsFilterReducer,
  getAllMaintainedTherapist,
  getAllAnnouncementReducer,
  createAnnouncementReducer,
  updateAnnouncementReducer,
  deleteAnnouncementReducer,
  getTherapyPlanning7dayLookBack,
  therapistDailyUpdatesReducer,
  dashboardSupervisorEditReducer,
  checkAllowDischargeReducer,
  recheckDischargeOverrideStatusReducer,
  approveRecheckDischargeReducer,
  newDocumentSignReducer,
  undoDocumentSignReducer,
  holdDailyNoteFromBillingReducer,
  checkPendingDocsAlert,
  setCommonDurationReducer,
  dueDocSettingsReducer,
  otherDashboardDocumentListReducer,
  myDashboardDocumentListReducer,
  coSignatureReviewReducer,
  therapistBulkSignatureReducer,
  signingPinReducer,
  getDailySessionPatientInfoV2,
  getDailyNotesPrintStatusReducer,
  deleteDailySessionNoteReducer,
  archiveDailySessionNoteReducer,
  getArchivedDocumentsReducer,
  SplitTaskMinReducer,
  editSplitTaskMinReducer,
  getSplitTaskReducer,
  deleteSplitTaskReducer,
  checkSplitMinInPlanner,
  getSupervisoryAlertReducer,
  getSupervisoryAlertSettingReducer,
  getTherapistInfoReducer,
  addSignOnBehalfReducer,
  getDsnSummaryReducer,
  createPatientPayerReducer,
  getAllPatientPayersReducer,
  getPayerOptionsReducer,
  getPayerDateRangesReducer,
  getPayerHistoryReducer,
  updatePatientPayerReducer,
  getAllPhysiciansReducer,
  getPendingSignaturePhysiciansReducer,
  reopenCloseoutReducer,
  createCustomCloseoutReducer,
  updateCustomCloseoutReducer,
  cancelCustomCloseoutReducer,
  getPayerFiltersReducer,
  getPatientFiltersReducer,
  getTherapistFiltersReducer,
  searchPatientsReducer,
  getPatientIntervalsReducer,
  getPatientDocumentsReducer,
  getDocumentSummaryReducer,
  getDownloadJobsReducer,
  submitDownloadJobReducer,
  getPresignedUrlReducer,
  verifyMdsPpsReducer,
  validateMdsPayerReducer,
  getPbjExportReducer,
});

export default rootRedcer;
